import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
} from 'firebase/firestore';
import { db } from '../lib/firebase';
import { BlogPost } from '../types';
import { parseDate } from './firestoreUtils';

const COLLECTION = 'blogPosts';

export async function getBlogPosts(): Promise<BlogPost[]> {
  const q = query(collection(db, COLLECTION), orderBy('publishedAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      title: data.title || '',
      excerpt: data.excerpt || '',
      content: data.content || '',
      author: data.author || '',
      publishedAt: parseDate(data.publishedAt) || new Date(),
      category: data.category || 'General',
      tags: data.tags || [],
      image: data.image || '',
      readTime: data.readTime || 5,
    };
  });
}

export async function addBlogPost(post: Omit<BlogPost, 'id'>): Promise<string> {
  const docRef = await addDoc(collection(db, COLLECTION), {
    ...post,
    publishedAt: post.publishedAt.toISOString(),
  });
  return docRef.id;
}

export async function updateBlogPost(id: string, post: Omit<BlogPost, 'id'>): Promise<void> {
  await updateDoc(doc(db, COLLECTION, id), {
    ...post,
    publishedAt: post.publishedAt.toISOString(),
  });
}

export async function deleteBlogPost(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTION, id));
}
